import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CartProvider } from './components/CartContext';
import { CurrencyProvider } from './components/CurrencyContext';
import { CartDrawer } from './components/CartDrawer';
import { FloatingCta } from './components/FloatingCta';
export function App() {
  useEffect(() => {
    // Facebook Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      f.fbq = function () {
        f.fbq.callMethod ? f.fbq.callMethod.apply(f.fbq, arguments) : f.fbq.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = f.fbq;
      f.fbq.push = f.fbq;
      f.fbq.loaded = true;
      f.fbq.version = '2.0';
      f.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '945755351435014');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <CurrencyProvider data-id="element-0">
      <CartProvider data-id="element-1">
        <LandingPage data-id="element-2" />
        <CartDrawer data-id="element-3" />
        <FloatingCta data-id="element-4" />
      </CartProvider>
    </CurrencyProvider>;
}